import { Scene } from 'phaser';
import { Actor } from '../models/Actor';
import { Utils } from '../services/Utils';
import { ActorType } from '../models/ActorType';
import { Words } from '../services/Words';
import i18next from 'i18next';

export class Game extends Scene
{
    camera: Phaser.Cameras.Scene2D.Camera;
    background: Phaser.GameObjects.Image;
    overlay: Phaser.GameObjects.Image;
    actors: Actor[] = [];
    playerSpeed = 5.0;
    
    pointsScored = 0;
    score: Phaser.GameObjects.Text;
    scoreText = "";
    debugText = "";
    countdown: Phaser.GameObjects.Text;
    countdownText = "";
    lastPaused = new Date().getTime();
    //lastUnPaused = new Date().getTime();
    pauseDialogTitle: Phaser.GameObjects.Text;
    canExit = false;
    //lastWinningWord = new Date().getTime();
    night = new Phaser.Display.Color(0, 0, 54);
    day = new Phaser.Display.Color(255,255,255);
    sun: Phaser.GameObjects.Image;

    wateringcanEmitter: Phaser.GameObjects.Particles.ParticleEmitter;
    lastWatered = new Date().getTime();
    timeToPlay = 5 * 60 * 1000;
    startTime = new Date().getTime();

    tutorialGamepad: Phaser.GameObjects.Sprite;
    tutorial: Phaser.GameObjects.Text;
    tutorialNr = 0;
    tutorialTexts = ["tut0",
        "tut1",
        "tut2",
        "tut3",
        "tut4",
        "tut5",
        "tut6"
    ];
    cursors: any;
    spaceKey: Phaser.Input.Keyboard.Key;
    escapeKey: Phaser.Input.Keyboard.Key;

    constructor ()
    {
        super('Game');
    }

    create ()
    {
        if (this.input.keyboard) {
            this.cursors = this.input.keyboard.createCursorKeys();
            this.spaceKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
            this.escapeKey= this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC);
        }        

        //console.log("Game.create");
        this.actors = [];
        this.pointsScored = 0;
        this.lastPaused = new Date().getTime();
        this.canExit = false;
        //this.lastWinningWord = new Date().getTime();
        this.startTime = new Date().getTime();
        this.tutorialNr = (Utils.getTutorialDone() ? -1 : 0);

        this.camera = this.cameras.main;
        this.background = this.add.image(512, 384, 'bg2');   
        this.background.scale = 5;     
        
        this.score = this.add.text(20, 20, this.scoreText, {
                fontFamily: 'Arial Black', fontSize: 24, color: '#ffffff',
                stroke: '#000000', strokeThickness: 6,
                align: 'center'
            });
        this.score.depth = 1000;
        this.countdown = this.add.text(1024 - 80, 20, this.countdownText, {
                fontFamily: 'Arial Black', fontSize: 24, color: '#ffffff',
                stroke: '#000000', strokeThickness: 6,
                align: 'right'
            });
        this.countdown.depth = 1000;
        this.tutorial = this.add.text(512, 250, this.scoreText, {
                fontFamily: 'Arial Black', fontSize: 24, color: '#ffffff',
                stroke: '#000000', strokeThickness: 6,
                align: 'center'
            });
        this.tutorial.depth = 1000;
        this.tutorial.setOrigin(0.5);

        if (!this.anims.exists('gamepad_handle')) {
            this.anims.create({
                key: 'gamepad_handle',
                frames: this.anims.generateFrameNumbers("gamepad_handle", { start: 0, end: 2}),
                frameRate: 5,
                yoyo: true,
                repeat: -1
            });
        }
        if (!this.anims.exists('gamepad_a_button')) {
            this.anims.create({
                key: 'gamepad_a_button',
                frames: this.anims.generateFrameNumbers("gamepad_a_button", { start: 0, end: 1}),
                frameRate: 5,
                yoyo: true,
                repeat: -1
            });
        }
        if (this.tutorialNr == 0) {
            this.tutorialGamepad = this.add.sprite(512, 100, "gamepad");
            this.tutorialGamepad.setOrigin(0.5);
            this.tutorialGamepad.anims.play('gamepad_handle');
            this.tutorialGamepad.scale = 0.5;
            this.tutorialGamepad.depth = 1000;
        }        

        this.sun = this.add.image(512, 700, "sun");
        this.sun.setOrigin(0.5, 1);
        this.sun.depth = 0.1;
        this.sun.scale = 0.5;
        //this.sun.alpha = 0.5;
        this.overlay = this.add.image(512, 384, 'bg_overlay');
        this.overlay.depth = 0.2;
        //this.overlay.scale = 5;

        for (let i = 1; i <= 4; i++) {
            if (!this.anims.exists('walk_player' + i)) {
                this.anims.create({
                    key: 'walk_player' + i,
                    frames: this.anims.generateFrameNumbers("player" + i, { start: 0, end: 4}),
                    frameRate: 30,
                    yoyo: true,
                    repeat: -1
                });
            }

            const actor = new Actor();
            actor.sprite = this.add.sprite(25 + (i * 75), 500, "player" + i);
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.Player;
            actor.collisionRectangle = this.add.rectangle(25 + (i * 75), 500, 30, 20, 0xffffff);
            actor.collisionRectangle.setOrigin(0.5, 1);
            actor.collisionRectangle.visible = false;
            actor.takeRectangle = this.add.rectangle(25 + (i * 75), 500, 20, 50, 0xffffff);
            actor.takeRectangle.setOrigin(0.5, 1);
            actor.takeRectangle.visible = false;
            // shadow
            actor.shadow = this.add.sprite(25 + (i * 75), 500, "player" + i);
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //
            this.actors.push(actor);
        }
        
        for (let i = 1; i <= 4; i++) {
            if (!this.anims.exists('fly_bee' + i)) {
                this.anims.create({
                    key: 'fly_bee' + i,
                    frames: this.anims.generateFrameNumbers("bee" + i, { start: 0, end: 4}),
                    frameRate: 100,
                    yoyo: true,
                    repeat: -1
                });
            }
        }

        for (let i = 0; i < 11; i++) {
            const actor = new Actor();
            actor.sprite = this.add.sprite(110 + (i * 80), 730, "flowerpot");
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.Flowerpot;
            actor.collisionRectangle = this.add.rectangle(110 + (i * 80), 730, 60, 20, 0xffffff);
            actor.collisionRectangle.setOrigin(0.5, 1);
            actor.collisionRectangle.visible = false;
            // shadow
            actor.shadow = this.add.sprite(110 + (i * 80), 730, "flowerpot");
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //actor.shadow.blendMode = BlendModes.ADD;
            //
            this.actors.push(actor);

            this.plantSeed(actor);
        }

        for (let i = 0; i < 3; i++) {
            const actor = new Actor();
            actor.sprite = this.add.sprite(100 + (i * 75), 550, "vase");
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.Vase;
            actor.collisionRectangle = this.add.rectangle(100 + (i * 75), 550, 150, 50, 0xffffff);
            actor.collisionRectangle.setOrigin(0.5, 1);
            actor.collisionRectangle.visible = false;
            actor.group = 1;
            actor.order = i + 1;
            // shadow
            actor.shadow = this.add.sprite(100 + (i * 75), 550, "vase");
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //
            this.actors.push(actor);
        }

        for (let i = 0; i < 4; i++) {
            const actor = new Actor();
            actor.sprite = this.add.sprite(400 + (i * 75), 550, "vase");
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.Vase;
            actor.collisionRectangle = this.add.rectangle(400 + (i * 75), 550, 150, 50, 0xffffff);
            actor.collisionRectangle.setOrigin(0.5, 1);
            actor.collisionRectangle.visible = false;
            actor.group = 2;
            actor.order = i + 1;
            // shadow
            actor.shadow = this.add.sprite(100 + (i * 75), 550, "vase");
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //
            this.actors.push(actor);
        }

        for (let i = 0; i < 5; i++) {
            const actor = new Actor();
            actor.sprite = this.add.sprite(700 + (i * 60), 500, "vase");
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.Vase;
            actor.collisionRectangle = this.add.rectangle(700 + (i * 60), 500, 150, 50, 0xffffff);
            actor.collisionRectangle.setOrigin(0.5, 1);
            actor.collisionRectangle.visible = false;
            actor.group = 3;
            actor.order = i + 1;
            // shadow
            actor.shadow = this.add.sprite(100 + (i * 75), 550, "vase");
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //
            this.actors.push(actor);
        }

        {
            const actor = new Actor();
            actor.sprite = this.add.sprite(900, 550, "wateringcan");
            actor.sprite.setOrigin(0.5, 1);
            actor.actorType = ActorType.WateringCan;
            // shadow
            actor.shadow = this.add.sprite(900, 550, "wateringcan");
            actor.shadow.setOrigin(0.5, 1);
            actor.shadow.tint = 0x000000;
            actor.shadow.depth = 1;
            //
            this.actors.push(actor);
            //const emitZone = { type: 'edge', source: actor.sprite.getBounds(), quantity: 42 };
            this.wateringcanEmitter = this.add.particles(0, 0, 'water', {
                speed: 24,
                gravityY: 250,
                //advance: 2000,
                lifespan: 1000,
                //quantity: 10,
                scale: { start: 0.1, end: 0 },
                //emitZone: emitZone,
                //duration: 500,
                emitting: false
            });
            this.wateringcanEmitter.depth = 799;
        }
        
        this.spawnBee();

        this.input.gamepad?.on("down", (gamepad: Phaser.Input.Gamepad.Gamepad) =>{
            if (gamepad.buttons[9].pressed) {
                if (this.lastPaused + (1000) < new Date().getTime()) {
                    this.exitGame();
                }
            }            
        });

        // Hack to unpause game!!
        setInterval(() => {
            //console.log("paused? " + this.p);
            if (!this.scene.isPaused) return;

            const pad = navigator.getGamepads()[0];
            if (pad) {
                if (pad.buttons[0].pressed) {
                    this.canExit = false;
                    this.scene.resume();

                    if (this.pauseDialogTitle) {
                        this.pauseDialogTitle.destroy();
                    }                    
                }

                if (this.canExit && pad.buttons[1].pressed) {
                    window.close();
                }
            }
            //}
        }, 500);
    } 

    exitGame() {
        this.lastPaused = new Date().getTime();
        this.scene.pause();               
        
        const pad = navigator.getGamepads()[0];
        if (pad) {
            this.pauseDialogTitle = this.add.text(512, 768/2, i18next.t("exit"), {
                fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                stroke: '#000000', strokeThickness: 8,
                align: 'center'
            }).setOrigin(0.5);
        }
        else {
            this.pauseDialogTitle = this.add.text(512, 768/2, i18next.t("exitkeyboard"), {
                fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                stroke: '#000000', strokeThickness: 8,
                align: 'center'
            }).setOrigin(0.5);
        }
        this.pauseDialogTitle.depth = 1000;

        this.canExit = true;
    }

    spawnBee() {
        const thingsWithAttachments = this.actors.filter(a => a.attachedTo != null).map(m => m.attachedTo?.id);
        const flowerpotsWithoutPlants = this.actors.filter(a => a.actorType == ActorType.Flowerpot && 
            !thingsWithAttachments.includes(a.id));

        let flowerpot: Actor | null;
        flowerpot = null;
        if (flowerpotsWithoutPlants.length > 0) {
            flowerpot = flowerpotsWithoutPlants[Utils.getRandomInt(flowerpotsWithoutPlants.length)];
        }         

        const path = new Phaser.Curves.Path(0, Utils.getRandomInt(500));

        path.splineTo([ new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
             new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
             new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
             new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500))]);
        if (flowerpot) {
            path.splineTo([new Phaser.Math.Vector2(flowerpot.sprite.x, flowerpot.sprite.y - 40)]);
        }             
        path.splineTo([ new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
            new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
            new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
            new Phaser.Math.Vector2(Utils.getRandomInt(1024), Utils.getRandomInt(500)),
            new Phaser.Math.Vector2(1024, Utils.getRandomInt(500)) ]);

        const startPosition = path.getPoint(0);
        
        const actor = new Actor();
        let nr = Utils.getRandomInt(4) + 1;
        actor.sprite = this.add.sprite(startPosition.x, startPosition.y, "bee" + nr);
        actor.sprite.setOrigin(0.5, 1);
        actor.actorType = ActorType.Bee;
        actor.needsScaling = false;
        actor.sprite.depth = 800;
        actor.sprite.anims.play('fly_bee' + nr);
        //this.actors.push(actor);

        this.tweens.addCounter({
            from: 0,
            to: 1,
            ease: 'linear',
            duration: 20000,
            repeat: 0,
            yoyo: false,
            onUpdate: tween =>
            {
                const prevX = actor.sprite.x;
                const position = path.getPoint(tween.getValue());

                if (prevX < position.x) {
                    actor.sprite.flipX = false;
                }
                else {
                    actor.sprite.flipX = true;
                }

                actor.sprite.setPosition(position.x, position.y);
            },
            onComplete: _ =>
            {
                if (flowerpot) {
                    this.plantSeed(flowerpot);
                }
                
                actor.sprite.destroy();

                this.spawnBee();
            }
        });
    }
    
    plantSeed(flowerpot: Actor) {
        // check of er al een bloem instaat
        const plants = this.actors.filter(a => a.attachedTo != null && a.attachedTo.id == flowerpot.id);
        if (plants.length > 0) return;
        //

        let actor = new Actor();
        actor.sprite = this.add.sprite(flowerpot.sprite.x, flowerpot.sprite.y, "bud");
        actor.sprite.setOrigin(0.5, 1);
        actor.sprite.depth = flowerpot.sprite.depth + 1;
        actor.actorType = ActorType.Bud;
        actor.attachedTo = flowerpot;
        actor.realScale = 0.1;
        // shadow
        actor.shadow = this.add.sprite(flowerpot.sprite.x, flowerpot.sprite.y, "bud");
        actor.shadow.setOrigin(0.5, 1);
        actor.shadow.tint = 0x000000;
        actor.shadow.depth = 1;
        //actor.shadow.blendMode = BlendModes.ADD;
        //
        this.actors.push(actor);
        this.tweens.add({
            targets: actor,
            realScale: 1,
            duration: 1000,
            yoyo: false,
            ease: 'Linear',
            repeat: 0
        });

        this.time.delayedCall(5000, (actor: Actor) =>{
            actor.sprite.setTexture("plant");
            // shadow
            actor.shadow.setTexture("plant");
            //
            actor.realScale = 0.7;
            this.tweens.add({
                targets: actor,
                realScale: 1,
                duration: 1000,
                yoyo: false,
                ease: 'Linear',
                repeat: 0
            });
        }, [actor], this);

        this.time.delayedCall(10000, (actor: Actor) =>{
            actor.sprite.setTexture("flower" + (Utils.getRandomInt(8) + 1));
            // shadow
            actor.shadow.setTexture("flower" + (Utils.getRandomInt(8) + 1));
            //
            const selection = this.actors.filter(f => f.attachedTo && f.attachedTo.actorType == ActorType.Flowerpot).map(m => m.letter).join('');
            actor.letter = Utils.getRandomLetter(selection);
            actor.letterPlant = this.add.text(actor.sprite.x, actor.sprite.y, actor.letter.toUpperCase(), {
                    fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                    stroke: '#000000', strokeThickness: 8,
                    align: 'center'
                });
            actor.letterPlant.setOrigin(0.5, 1);
            actor.actorType = ActorType.LetterPlant;
            actor.realScale = 0.7;
            this.tweens.add({
                targets: actor,
                realScale: 1,
                duration: 1000,
                yoyo: false,
                ease: 'Linear',
                repeat: 0
            });
        }, [actor], this);
    }

    validateWord(letterPlant: Actor) {
        const plants = this.actors.filter(f => f.attachedTo && f.attachedTo.group == letterPlant.attachedTo?.group).sort((n1: Actor,n2: Actor) => {
            if (n1.attachedTo && n2.attachedTo && n1.attachedTo.order > n2.attachedTo.order) {
                return 1;
            }
        
            if (n1.attachedTo && n2.attachedTo && n1.attachedTo.order < n2.attachedTo.order) {
                return -1;
            }

            return 0;
        });
        const totalNeeded = this.actors.filter(f => f.group == letterPlant.attachedTo?.group).length;
        if (plants.length < totalNeeded) return;
        const word = plants.map(m => m.letter).join('');
        
        if (Words.isWordOk(word)) {
            //this.lastWinningWord = new Date().getTime();

            const margin = 200 / plants.length; // 3 = 1, 4 = 1.5, 5 = 2
            const startMargin = ((plants.length / 2) - 0.5) * margin;
            for(let i = 0; i < plants.length; i++) {
                const flower = this.add.sprite(512 - startMargin + (i * margin), (768/2), plants[i].sprite.texture);
                flower.scale = 0.1;
                flower.depth = 999;
                this.tweens.add({
                    targets: flower,
                    scale: 1,
                    duration: 3000,
                    yoyo: false,
                    ease: 'Bounce.Out',
                    repeat: 0,
                    onComplete: _ =>
                        {
                            flower.destroy();
                        }
                });         

                plants[i].sprite.destroy();
                plants[i].letterPlant.destroy();
    
                let index = this.actors.indexOf(plants[i]);
                this.actors.splice(index, 1);
            }

            const points = plants.length * (plants.length - 2);
            this.pointsScored += points;

            this.sound.play("glad" + (Utils.getRandomInt(3) + 1));
            let winningWord = this.add.text(512, 768/2, word.toUpperCase(), {
                fontFamily: 'Arial Black', fontSize: 76, color: '#ffffff',
                stroke: '#000000', strokeThickness: 16,
                align: 'center'
            }).setOrigin(0.5);
            winningWord.scale = 0.01;
            winningWord.depth = 1000;
            this.tweens.add({
                targets: winningWord,
                scale: 1,
                duration: 3000,
                yoyo: false,
                ease: 'Bounce.Out',
                repeat: 0,
                onComplete: _ =>
                    {
                        winningWord.destroy();
                    }
            });

            let bonusPoints = this.add.text(512, 768/1.8, "+" + points.toString() + "!", {
                fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                stroke: '#000000', strokeThickness: 8,
                align: 'center'
            }).setOrigin(0.5);
            bonusPoints.scale = 0.01;
            bonusPoints.depth = 1000;
            this.tweens.add({
                targets: bonusPoints,
                scale: 1,
                duration: 3000,
                yoyo: false,
                ease: 'Bounce.Out',
                repeat: 0,
                onComplete: _ =>
                    {
                        bonusPoints.destroy();
                    }
            });
            if (this.tutorialNr == 3) {
                this.tutorialNr = 4;
                this.tutorialGamepad.visible = true;
            }
        }      
        else {
            this.sound.play("leaves1");
            for(let i = 0; i < plants.length; i++) {
                this.tweens.add({
                    targets: plants[i],
                    realScale: 0.1,
                    duration: 1000,
                    yoyo: false,
                    ease: 'Linear',
                    repeat: 0,
                    onComplete: _ =>
                        {
                            plants[i].sprite.destroy();
                            plants[i].letterPlant.destroy();

                            let index = this.actors.indexOf(plants[i]);
                            this.actors.splice(index, 1);
                        }
                });     
                this.tweens.add({
                    targets: plants[i].sprite,
                    tint: 0x964B00,
                    duration: 1000,
                    yoyo: false,
                    ease: 'Linear',
                    repeat: 0
                });                
            }
        }  
    }

    gieten(wateringCan: Actor) {
        const thingsWithAttachments = this.actors.filter(a => a.attachedTo != null).map(m => m.attachedTo?.id);
        const flowerpotsWithoutPlants = this.actors.filter(a => a.actorType == ActorType.Flowerpot && 
            !thingsWithAttachments.includes(a.id));
        
        let intersection = false;
        let flowerpot: Actor | null = null;
        for (let i = 0; i < flowerpotsWithoutPlants.length; i++) {
            const nozzle = new Phaser.Geom.Rectangle(wateringCan.sprite.flipX ? wateringCan.sprite.x + 70 : wateringCan.sprite.x - 70, wateringCan.sprite.y, 30, 30);
            intersection = Phaser.Geom.Intersects.RectangleToRectangle(flowerpotsWithoutPlants[i].sprite.getBounds(), nozzle); //wateringCan.sprite.getBounds());
            if (intersection) {
                flowerpot = flowerpotsWithoutPlants[i];
                break;
            }
        }

        if (intersection) {
            this.wateringcanEmitter.x = wateringCan.sprite.flipX ? wateringCan.sprite.x + 70 : wateringCan.sprite.x - 70;
            this.wateringcanEmitter.y = wateringCan.sprite.y - 50;
            this.wateringcanEmitter.start();
            if (flowerpot) {
                if (this.lastWatered + (1000) < new Date().getTime()) {
                    this.lastWatered = new Date().getTime();
                    this.sound.play("splash3");
                }
                this.time.delayedCall(3000, () => {
                    if (flowerpot) {
                        this.plantSeed(flowerpot);
                    }
                });                
            }
        }
        else {
            this.wateringcanEmitter.stop();
        }
    }

    updateShadow(actor: Actor, i: number, scale: number, brightness: number, scaledMod: number) {
        //actor.sprite.tint = Phaser.Display.Color.GetColor(Math.max(255 * brightness, 100), Math.max(255 * brightness, 20), Math.max(255 * brightness, 20));
        if (!actor.shadow) return;

        // if (scaledMod > 0) {
        //     actor.shadow.depth = 0.8;
        // }
        actor.shadow.setPosition(actor.sprite.x, actor.sprite.y - (20 * scale) + scaledMod);
        actor.shadow.scaleX = scale * actor.realScale;
        actor.shadow.scaleY = (scale * actor.realScale) * (1.3 - brightness);
        const angle = 270 - (brightness * 100);
        const rotation = Phaser.Math.DegToRad(angle);
        actor.shadow.setRotation(rotation);
        actor.shadow.alpha = brightness / 3;
        if (actor.sprite.anims) {
            if (actor.sprite.anims.isPlaying && !actor.shadow.anims.isPlaying) {
                actor.shadow.anims.play('walk_player' + (i + 1));
            }
            if (!actor.sprite.anims.isPlaying && actor.shadow.anims.isPlaying) {
                actor.shadow.anims.stop();
            }
        }
        actor.shadow.flipX = !actor.sprite.flipX;
    }

    interact(i: number) {
        if (this.actors[i].lastUpdate + (1000) < new Date().getTime()) {
            let attachedToMe = this.actors.filter(a => a.attachedTo != null && a.attachedTo.id == this.actors[i].id).length;
            for (let j = 0; j < this.actors.length; j++) {
                if (this.actors[i].id != this.actors[j].id) {
                    // PLUKKEN
                    if (this.actors[j].actorType == ActorType.LetterPlant && this.actors[j].attachedTo != null && attachedToMe == 0) {
                        const intersection = Phaser.Geom.Intersects.RectangleToRectangle(this.actors[i].takeRectangle.getBounds(), this.actors[j].sprite.getBounds());
                        if (intersection) {
                            if (this.actors[j].attachedTo && this.actors[j].attachedTo?.actorType == ActorType.Vase) {
                                this.sound.play("splash2");
                            }
                            else {
                                this.sound.play("scissors1");
                                if (this.tutorialNr == 1) this.tutorialNr = 2;
                            }
                            attachedToMe = this.actors.filter(a => a.attachedTo != null && a.attachedTo.id == this.actors[i].id).length;
                            if (attachedToMe == 0) {
                                this.actors[j].attachedTo = this.actors[i];
                            }
                            this.actors[i].lastUpdate = new Date().getTime();

                            // const wateringCan = this.actors.filter(a => a.actorType == ActorType.WateringCan && a.attachedTo && a.attachedTo.id == this.actors[i].id)[0];
                            // if (wateringCan) {
                            //     wateringCan.attachedTo = null;
                            // }    
                        }
                    }
                    
                    // IN VAAS ZETTEN
                    if (this.actors[j].actorType == ActorType.Vase && attachedToMe == 1)// && this.actors[i].attachedTo && this.actors[i].attachedTo?.actorType == ActorType.LetterPlant) 
                    {
                        const intersection = Phaser.Geom.Intersects.RectangleToRectangle(this.actors[i].takeRectangle.getBounds(), this.actors[j].sprite.getBounds());
                        if (intersection) {
                            const attachedToVase = this.actors.filter(a => a.attachedTo && a.attachedTo.id == this.actors[j].id).length;
                            if (attachedToVase == 0) {
                                const letterPlant = this.actors.filter(a => a.actorType == ActorType.LetterPlant && a.attachedTo && a.attachedTo.id == this.actors[i].id)[0];
                                if (letterPlant) {
                                    this.sound.play("splash1");
                                    letterPlant.attachedTo = this.actors[j];
                                    this.actors[i].lastUpdate = new Date().getTime();

                                    this.validateWord(letterPlant);
                                    if (this.tutorialNr == 2) {
                                        this.tutorialNr = 3;
                                        this.tutorialGamepad.visible = false;  
                                    } 
                                }                                        
                            }                                    
                        }
                    }

                    // GIETER OPPAKKEN
                    if (this.actors[i].lastUpdate + (1000) < new Date().getTime()) {
                        if (this.actors[j].actorType == ActorType.WateringCan && attachedToMe == 0) {
                            const intersection = Phaser.Geom.Intersects.RectangleToRectangle(this.actors[i].takeRectangle.getBounds(), this.actors[j].sprite.getBounds());
                            if (intersection) {
                                attachedToMe = this.actors.filter(a => a.attachedTo != null && a.attachedTo.id == this.actors[i].id).length;
                                if (attachedToMe == 0) {
                                    this.actors[j].attachedTo = this.actors[i];
                                }
                                this.actors[i].lastUpdate = new Date().getTime();
                                if (this.tutorialNr == 4) this.tutorialNr = 5;
                            }
                        }
                    }
                }
            }

            // GIETER NEERZETTEN
            if (this.actors[i].lastUpdate + (1000) < new Date().getTime()) {
                const wateringCan = this.actors.filter(a => a.actorType == ActorType.WateringCan && a.attachedTo && a.attachedTo.id == this.actors[i].id)[0];
                if (wateringCan) {
                    wateringCan.attachedTo = null;
                    this.wateringcanEmitter.stop();
                    this.actors[i].lastUpdate = new Date().getTime();
                    if (this.tutorialNr == 5) this.tutorialNr = 6;
                }                            
            }
        }

        if (this.actors[i].lastUpdate + (1000) < new Date().getTime()) {
            if (this.tutorialNr == 6) {
                this.tutorialNr = -1;
                this.pointsScored = 0;
                this.tutorialGamepad.destroy();
                Utils.setTutorialDone(true);
                this.actors[i].lastUpdate = new Date().getTime();
            } 
        }
    }

    update() {
        if (this.tutorialNr >= 0) {
            this.startTime = new Date().getTime();
        }

        const brightness = 1 - ((new Date().getTime() - this.startTime) / this.timeToPlay);
        this.background.tint = Phaser.Display.Color.GetColor(Math.max(255 * brightness, 20), Math.max(255 * brightness, 60), Math.max(255 * brightness, 100));
        this.overlay.tint = Phaser.Display.Color.GetColor(Math.max(255 * brightness, 100), Math.max(255 * brightness, 60), Math.max(255 * brightness, 20));
        const realCountdown = this.timeToPlay - (new Date().getTime() - this.startTime);
        this.countdownText = Utils.msToTime(realCountdown);
        if (brightness <= 0) {
            Utils.saveScore(this.pointsScored);
            this.scene.start('GameOver');
        }

        for (let i = 0; i < this.actors.length; i++) {
            let scale = Phaser.Math.Interpolation.Linear([0.3, 1], (this.actors[i].sprite.y - 420) / (768 - 420));

            const pad = this.input.gamepad?.getPad(i);

            var axisH: number = 0;
            var axisV: number = 0;

            if (pad) {
                if (pad.A) {
                    this.interact(i);
                }

                axisH = pad.axes[0].getValue();
                axisV = pad.axes[1].getValue();
                
            }        
            else {
                // KEYBOARD
                if (this.input.keyboard && i == 0) {
                    if (this.spaceKey.isDown) {
                        this.interact(i);

                        // if (this.scene.isPaused()) {
                        //     this.canExit = false;
                        //     this.scene.resume();
        
                        //     if (this.pauseDialogTitle) {
                        //         this.pauseDialogTitle.destroy();
                        //     }   
                        // }
                    }

                    if (this.cursors.left.isDown)
                    {
                        axisH = -1;
                    }
                    else if (this.cursors.right.isDown)
                    {
                        axisH = 1;
                    }
            
                    if (this.cursors.up.isDown)
                    {
                        axisV = -1;
                    }
                    else if (this.cursors.down.isDown)
                    {
                        axisV = 1;
                    }
                }
            }

            if (axisH < 0) {
                this.actors[i].sprite.flipX = true;

                const wateringCan = this.actors.filter(a => a.actorType == ActorType.WateringCan && a.attachedTo && a.attachedTo.id == this.actors[i].id)[0];
                if (wateringCan) {
                    wateringCan.sprite.flipX = false;
                    this.gieten(wateringCan);
                }                    
            }
            if (axisH > 0) {
                this.actors[i].sprite.flipX = false;

                const wateringCan = this.actors.filter(a => a.actorType == ActorType.WateringCan && a.attachedTo && a.attachedTo.id == this.actors[i].id)[0];
                if (wateringCan) {
                    wateringCan.sprite.flipX = true;
                    this.gieten(wateringCan);
                }
            }
            if (axisH == 0 && axisV == 0 && this.actors[i].sprite.anims) {
                this.actors[i].sprite.anims.stop();
            }
            else {
                if (this.actors[i].sprite.anims && !this.actors[i].sprite.anims.isPlaying) {
                    this.actors[i].sprite.anims.play('walk_player' + (i + 1));
                }
                if (this.tutorialNr == 0) {
                    this.tutorialNr = 1;
                    this.tutorialGamepad.anims.play('gamepad_a_button');
                } 
            }

            let oldX = this.actors[i].sprite.x;
            let oldY = this.actors[i].sprite.y;
            var newX = this.actors[i].sprite.x + (axisH * this.playerSpeed);
            var newY = this.actors[i].sprite.y + (axisV * this.playerSpeed);

            // boundaries
            if (newX < 10) newX = 10;
            if (newX > 1024 - 10) newX = 1024 - 10;
            if (newY < 480) newY = 480;
            if (newY > 768 - 10) newY = 768 - 10;

            // collision
            for (let j = 0; j < this.actors.length; j++) {
                if (this.actors[i] != this.actors[j]) {
                    if (this.actors[i].collisionRectangle && this.actors[j].collisionRectangle) {
                        // X                            
                        this.actors[i].collisionRectangle.setPosition(newX, oldY);                
                        const intersectionX = Phaser.Geom.Intersects.RectangleToRectangle(this.actors[i].collisionRectangle.getBounds(), this.actors[j].collisionRectangle.getBounds());
                        if (intersectionX) {
                            newX = oldX;
                        }
                        // Y
                        this.actors[i].collisionRectangle.setPosition(oldX, newY);                
                        const intersectionY = Phaser.Geom.Intersects.RectangleToRectangle(this.actors[i].collisionRectangle.getBounds(), this.actors[j].collisionRectangle.getBounds());
                        if (intersectionY) {
                            newY = oldY;
                        }
                    }
                } 
            }

            this.actors[i].sprite.setPosition(newX, newY);                
            if (this.actors[i].collisionRectangle) this.actors[i].collisionRectangle.setPosition(newX, newY);                
            if (this.actors[i].takeRectangle) this.actors[i].takeRectangle.setPosition(newX, newY - (100 * scale));  
            
            if (this.actors[i].needsScaling) {                
                this.actors[i].sprite.scale = scale * this.actors[i].realScale;
                if (this.actors[i].collisionRectangle) this.actors[i].collisionRectangle.scale = scale;
                if (this.actors[i].takeRectangle) this.actors[i].takeRectangle.scale = scale;
                this.actors[i].sprite.depth = this.actors[i].sprite.y;
            }            

            // attached sprites
            let scaledMod = 0;
            if (this.actors[i].attachedTo) {
                if (this.actors[i].attachedTo?.actorType == ActorType.Flowerpot) {
                    this.actors[i].sprite.depth = this.actors[i].attachedTo!.sprite.depth + 1;
                    scaledMod = 70 * scale;
                }
                if (this.actors[i].attachedTo?.actorType == ActorType.Vase) {
                    this.actors[i].sprite.depth = this.actors[i].attachedTo!.sprite.depth - 1;
                    scaledMod = 170 * scale;
                }
                if (this.actors[i].attachedTo?.actorType == ActorType.Player) {
                    this.actors[i].sprite.depth = this.actors[i].attachedTo!.sprite.depth + 1;
                    scaledMod = 60 * scale;
                }
                this.actors[i].sprite.setPosition(this.actors[i].attachedTo?.sprite.x, this.actors[i].attachedTo!.sprite.y - scaledMod);
            }

            // letterplants
            if (this.actors[i].letterPlant) {
                this.actors[i].letterPlant.scale = scale * this.actors[i].realScale;
                this.actors[i].letterPlant.depth = this.actors[i].sprite.depth + 1;
                scaledMod = 85 * scale;
                this.actors[i].letterPlant.setPosition(this.actors[i].sprite.x, this.actors[i].sprite.y - scaledMod);
            }

            // update shadow
            this.updateShadow(this.actors[i], i, scale, brightness, scaledMod);
            //
            // update sun
            const angle = (1 - brightness) * 90;
            //this.debugText = angle.toString();
            const rotation = Phaser.Math.DegToRad(angle);
            this.sun.setRotation(rotation);
        }

        // hud
        this.scoreText = i18next.t("score") + this.pointsScored; // + " | debug: " + this.debugText;
        this.score.setText(this.scoreText);
        this.countdown.setText(this.countdownText);
        this.tutorial.setText(i18next.t(this.tutorialTexts[this.tutorialNr]));

        if (this.escapeKey.isDown) {
            if (this.lastPaused + (1000) < new Date().getTime()) {
                this.exitGame();
            }
        }

    } 
}
